import { Alert, Snackbar } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';


export const AgcAlert = ({ open, severity, message, onClose, autoHideDuration, anchorOrigin }) => {

    const [alertOpen, setAlertOpen] = useState(open || false);
    const [alertSeverity, setAlertSeverity] = useState(severity || '');
    const [alertMessage, setAlertMessage] = useState(message || '');

    const { successMsg, errorMsg } = useSelector(state => state.common);


    useEffect(() => {
        if (successMsg) {
            setAlertMessage(successMsg)
            setAlertSeverity(severity || 'success')
            setAlertOpen(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [successMsg]);

    useEffect(() => {
        if (errorMsg) {
            setAlertMessage(errorMsg)
            setAlertSeverity(severity || 'error')
            setAlertOpen(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [errorMsg]);

    const handleAlertClick = () => {
        setAlertOpen(false)
        setTimeout(() => {
            setAlertSeverity(severity || '')
            setAlertMessage('')
            onClose()
        }, 300);
    };

    useEffect(() => {
        setAlertOpen(open)
    }, [open]);

    useEffect(() => {
        setAlertSeverity(severity)
    }, [severity]);

    useEffect(() => {
        setAlertMessage(message)
    }, [message]);

    return (
        <Snackbar
            open={alertOpen}
            anchorOrigin={anchorOrigin || { vertical: 'bottom', horizontal: 'center' }}
            autoHideDuration={autoHideDuration || 4000}
            onClose={() => handleAlertClick()}
        >
            <Alert
                severity={alertSeverity}
                variant='filled'
                onClose={() => handleAlertClick()}
            >
                {alertMessage || message || 'Unknown Alert!'}
            </Alert>
        </Snackbar>
    );
}

AgcAlert.propTypes = {
    open: PropTypes.bool,
    severity: PropTypes.string,
    message: PropTypes.string,
    onClose: PropTypes.func,
    autoHideDuration: PropTypes.number,
    anchorOrigin: PropTypes.object,
}

export const AGC_ALERT_OFF = { open: false, message: '' };
